import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Card, Typography, Image, Row, Col, Button, Modal, message, Empty, Dropdown, Menu, Upload, List, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, UploadOutlined, EyeOutlined } from "@ant-design/icons";
import axios from '../../../services/axios';
import ReactFlow, { MiniMap, Controls, Background, applyNodeChanges, applyEdgeChanges } from "reactflow";

const { Title, Text } = Typography;
 
const DocumentReference = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let documentData = location.state;
  const [workflow, setWorkflow] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [nodes, setNodes] = useState([]);
  const [edges, setEdges] = useState([]);
  const userType = localStorage.getItem('userType');
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [setDocumentData] = useState({});

  const ViewDocumentWorkflow = async () => {
    setLoading(true);
    setIsModalVisible(true);
    try {
      const res = await axios.post("get-document-workflow", { documentType: documentData.type, documentCategory: documentData.category, stage: documentData.stage });
      if(res && res.data && res.data.workflow){
        setWorkflow(res.data.workflow);
        setNodes(res.data.workflow.nodes || []);
        setEdges(res.data.workflow.edges || []);
      }
      setLoading(false)    
    } catch (err) {
      setLoading(false)
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong6');
      }
    }
  }

  // const uploadSupportingDocument = async () => {
   
  //   if (fileList.length === 0) {
  //     message.warning("Please upload a file.");
  //     return;
  //   }
  //   setLoading(true);

  //   const formData = new FormData();
  //   formData.append('file', fileList[0].originFileObj);
  //   formData.append('code', documentData.code);
  //   formData.append('documentReference', documentData.documentReference);

  //   try {
  //     const res = await axios.post("supporting-document", formData, {
  //       headers: {
  //         'Content-Type': 'multipart/form-data',
  //       },
  //     });

  //     if(res && res.data && res.data.document){
  //       setDocumentData(res.data.document); // ✅ triggers UI update
  //     }

  //     message.success("File uploaded successfully");
  //     setUploadModalVisible(false);
  //     setLoading(false);
  //   } catch (err) {
  //     setLoading(false)
  //     if (err.response && err.response.data && err.response.data.msg) {
  //       message.warning(err.response.data.msg);
  //     } else if (err.response && err.response.data && err.response.data.userName) {
  //       message.warning(err.response.data.userName[0]);
  //     } else if (err.response && err.response.status === 401) {
  //       message.error('User not authorized');
  //     } else {
  //       message.error('Something went wrong6');
  //     }
  //   }
  // };
  
  
  // const supportingMenu = (
  //   <Menu onClick={()=>setUploadModalVisible(true)}>
  //     <Menu.Item key="upload" icon={<UploadOutlined />} >
  //       Upload
  //     </Menu.Item>
  //   </Menu>
  // );

  const onNodesChange = (changes) => setNodes((nds) => applyNodeChanges(changes, nds));
  const onEdgesChange = (changes) => setEdges((eds) => applyEdgeChanges(changes, eds));
  
  return (
    <div className="p-4 sm:p-6 min-h-screen flex justify-center">
      {documentData ? (
        <Card className="w-full max-w-6xl shadow-lg rounded-lg">
          <div className="flex justify-between relative w-full mb-4 p-2">
            <Button
              icon={<ArrowLeftOutlined className="text-3xl" />}
              onClick={() => navigate(-1)}
              className=" left-0 text-black-600 text-lg hover:text-blue-800"
            />
            <Title level={2}>Document Details</Title>
            <div className="flex gap-2">
              <Button type="primary" loading={loading} onClick={ViewDocumentWorkflow}>
                View Workflow
              </Button>
              {/* <Dropdown overlay={supportingMenu} trigger={["click"]}>
                <Button type="default" loading={loading}>
                  Supporting Document
                </Button>
              </Dropdown>  */}
            </div>
          </div>

          {/* <Modal
            title="Upload Supporting Document"
            open={uploadModalVisible}
            onCancel={() => {
              setUploadModalVisible(false);
            }}
            footer={null}
          >
            <Upload
              name="document"
              fileList={fileList}
              onChange={({ fileList }) => setFileList(fileList)}
            >
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>

            
              <div className="mt-4">
                <Button
                  type="primary"
                  onClick={() => {
                    uploadSupportingDocument()
                  }}
                  loading={loading}
                >
                  Submit Document
                </Button>
              </div>
          </Modal> */}

          {/* 📄 View Modal */}
          {/* <Modal
            title="View Supporting Document"
            open={viewModalVisible}
            onCancel={() => setViewModalVisible(false)}
            footer={null}
            width={700}
            bodyStyle={{ maxHeight: "500px", overflowY: "auto" }}
          >
            {selectedDocument ? (
              /\.(jpg|jpeg|png|gif)$/i.test(selectedDocument) ? (
                <img
                  src={selectedDocument}
                  alt="Supporting Document"
                  style={{ maxWidth: "100%", borderRadius: "6px" }}
                />
              ) : (
                <a href={selectedDocument} target="_blank" rel="noopener noreferrer">
                  Open Document
                </a>
              )
            ) : (
              <p>No document selected.</p>
            )}
          </Modal> */}



          <Row gutter={[16, 16]} align="top">
            {/* Left Section - Revision History */}
            {userType !== "Consultant" && (
            <Col xs={24} sm={12} md={8}>
              <Card title="Revision History" bordered className="bg-gray-50 h-full">
                <div className="max-h-[450px] overflow-y-auto pr-2">
                  {documentData.revision || documentData.rejectionReasons?.length > 0 || 
                  Object.values(documentData.approvedDetails || {}).some(approval => approval?.approved) ? (
                    <>
                      {/* Approved Revisions */}
                      {Object.entries(documentData.approvedDetails || {}).reverse().map(([role, approval]) => (
                        approval?.approved ? (
                          <Card key={role} className="border p-3 mb-3 bg-gray-100">
                            <Text><strong>Version:</strong> {documentData.version || "N/A"}</Text><br />
                            <Text><strong>Reviewed By:</strong> {role}</Text><br />
                            <Text><strong>Status:</strong> Approved</Text><br />
                            <Text><strong>Approval Date:</strong> {approval.date ? new Date(approval.date).toLocaleDateString("en-GB") : "N/A"}</Text><br />
                            <Text><strong>Comment:</strong> {approval.comment || "No comments"}</Text>
                          </Card>
                        ) : null
                      ))}
                      {/* Rejection Reasons */}
                      {documentData.rejectionReasons?.slice().reverse().map((rejection, index) => (
                        <Card key={index} className="border p-3 mb-3 bg-gray-100">
                          <Text><strong>Version:</strong> {rejection.version || "N/A"}</Text><br />
                          <Text><strong>Reviewed By:</strong> {rejection.rejectedBy || "N/A"}</Text><br />
                          <Text><strong>Status:</strong> Rejected</Text><br />
                          <Text><strong>Rejected Date:</strong> {rejection.date ? new Date(rejection.date).toLocaleDateString("en-GB") : "N/A"}</Text><br />
                          <Text type="danger"><strong>Rejection Reason:</strong> {rejection.reason || "No reason provided"}</Text>
                        </Card>
                      ))}
                    </>
                  ) : (
                    <Text type="secondary">No revision history available.</Text>
                  )}
                </div>
              </Card>
            </Col>
            )}

            {/* Middle Section - Document Preview */}
            <Col xs={24} sm={8} md={8} className="flex justify-center items-center">
              <div className="bg-white p-2 rounded-lg shadow-md w-full">
                {documentData?.documentUrl && documentData.documentUrl.length > 0 ? (
                  documentData.documentUrl[documentData.documentUrl.length - 1].endsWith(".pdf") ? (
                    <>
                      <embed
                        src={documentData.documentUrl[documentData.documentUrl.length - 1]}
                        type="application/pdf"
                        width="100%"
                        height="450px"
                        className="rounded-lg"
                      />
                      <p className="text-center mt-2">
                        <a href={documentData.documentUrl[documentData.documentUrl.length - 1]} target="_blank" rel="noopener noreferrer">
                          Open PDF
                        </a>
                      </p>
                    </>
                  ) : (
                    <Image
                      src={documentData.documentUrl[documentData.documentUrl.length - 1]}
                      alt="Document Preview"
                      className="rounded-lg w-full"
                      height={450}
                      style={{ objectFit: "contain", backgroundColor: "white" }}
                    />
                  )
                ) : (
                  <Text type="secondary">No document available.</Text>
                )}
              </div>
            </Col>


            {/* Right Section - Document Details */}
            <Col xs={24} sm={12} md={8}>
              <Card bordered className="h-full">
                <Text><strong>Project Name:</strong> {documentData.projectName || "N/A"}</Text><br />
                <Text><strong>Change Reference:</strong> {documentData.changeReference || "N/A"}</Text><br />
                <Text><strong>Reference:</strong> {documentData.documentReference || "N/A"}</Text><br />
                <Text><strong>Category:</strong> {documentData.category || "N/A"}</Text><br />
                <Text><strong>Type:</strong> {documentData.type || "N/A"}</Text><br />
                <Text><strong>Uploaded Date:</strong> {new Date(documentData.uploadedDate).toLocaleDateString() || "N/A"}</Text><br />
                <Text><strong>Revision:</strong> {documentData.revision || "N/A"}</Text><br />
                <Text><strong>File Size:</strong> {documentData.fileSize ? documentData.fileSize : "N/A"}</Text><br />
              </Card>
            </Col>
            {/* <Col xs={24} sm={12} md={8}>
              <Card bordered className="h-full">
                <Text strong>Supporting Documents</Text>
                <br /><br />
                {Array.isArray(documentData?.supportingDocuments) && documentData.supportingDocuments.length > 0 ? (
                  <List
                    dataSource={documentData.supportingDocuments}
                    renderItem={(item, index) => (
                      <List.Item key={index}>
                        <Text strong>{index + 1}.</Text>&nbsp;
                        <a onClick={() => {
                          setSelectedDocument(item);
                          setViewModalVisible(true);
                        }}>
                          Document {index + 1}
                        </a>
                      </List.Item>
                    )}
                  />
                ) : (
                  <p>No supporting documents available.</p>
                )}
              </Card>
            </Col> */}


          </Row>
        </Card>
      ) : (
        <Text type="danger">No data available.</Text>
      )}

      <Modal
        title={`Type: ${Array.isArray(workflow?.documentType) ? workflow.documentType.join(", ") : workflow?.documentType || "Workflow"}`}
        open={isModalVisible}
        onCancel={()=> setIsModalVisible(false)}
        footer={[
          <Button key="close" onClick={()=> setIsModalVisible(false)} style={{ backgroundColor: "red", color: "white" }}>
            Close
          </Button>
        ]}
        width={800}
      >
        {workflow ? (
          <div style={{ height: "500px", background: "#f4f4f4", padding: "10px", borderRadius: "8px" }}>
            <ReactFlow nodes={nodes} edges={edges} onNodesChange={onNodesChange} onEdgesChange={onEdgesChange} fitView>
              <MiniMap />
              <Controls />
              <Background variant="dots" gap={12} size={1} />
            </ReactFlow>
          </div>
        ) : (
          <Empty description="No workflow data available" />
        )}
      </Modal>
    </div>
  );
};
 
export default DocumentReference;